var map = {
	"./auc.json": [
		"./src/router/menu/auc.json",
		"login"
	],
	"./cbd.json": [
		"./src/router/menu/cbd.json",
		4
	],
	"./ind.json": [
		"./src/router/menu/ind.json",
		8
	],
	"./mmr.json": [
		"./src/router/menu/mmr.json",
		2
	],
	"./vtn.json": [
		"./src/router/menu/vtn.json",
		5
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/router/menu lazy recursive ^\\.\\/.*\\.json$";
module.exports = webpackAsyncContext;